import { Component, Input } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import * as _ from 'lodash'

@Component({
  selector: 'control-hint',
  template: require('./control-hint.component.html'),
  styles: [require('./control-hint.component.sass')]
})

export class ControlHintComponent {
  @Input() hint: string
  @Input() direction: string = 'top'

  protected visible: boolean = false
  protected stopClick: boolean = true

  protected safeHint: SafeHtml

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    document.addEventListener('click', this.onClickHide)
    this.safeHint = this._sanitizer.bypassSecurityTrustHtml(this.hint)
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onClickHide)
  }

  onClickHide(event: MouseEvent) {
    if (this.stopClick) {
      this.stopClick = false
    } else {
      this.visible = false
    }
  }

  protected toggle() {
    this.stopClick = true
    this.visible = !this.visible
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/control-hint.component.ts